var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.268 9.76367C20.8719 9.76367 18.8252 10.1414 18.8252 11.6526C18.8252 13.1642 20.8591 13.5553 23.268 13.5553C25.6641 13.5553 27.7108 13.1781 27.7108 11.6664C27.7108 10.1548 25.6774 9.76367 23.268 9.76367Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.2681 8.32428C24.9003 8.32428 26.2081 7.01595 26.2081 5.38428C26.2081 3.75262 24.9003 2.44428 23.2681 2.44428C21.6365 2.44428 20.3281 3.75262 20.3281 5.38428C20.3281 7.01595 21.6365 8.32428 23.2681 8.32428Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93448 25.7637C7.53837 25.7637 5.4917 26.1414 5.4917 27.6526C5.4917 29.1642 7.52559 29.5553 9.93448 29.5553C12.3306 29.5553 14.3773 29.1781 14.3773 27.6664C14.3773 26.1548 12.3439 25.7637 9.93448 25.7637Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.93463 24.3243C11.5669 24.3243 12.8746 23.0159 12.8746 21.3843C12.8746 19.7526 11.5669 18.4443 9.93463 18.4443C8.30296 18.4443 6.99463 19.7526 6.99463 21.3843C6.99463 23.0159 8.30296 24.3243 9.93463 24.3243Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.9364 20C29.9364 25.16 25.763 29.3333 20.603 29.3333L22.003 27",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.26953 12C3.26953 6.84 7.44286 2.66666 12.6029 2.66666L11.2029 5",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount2);
export default __webpack_public_path__ + "static/media/account-2.5da3e07c71be5466940c223e56ab580c.svg";
export { ForwardRef as ReactComponent };